import styled from 'styled-components';

const ThemedLabel = styled.label`
  margin-bottom: ${({ $marginBottom }) => $marginBottom || '0.5rem'};
  font-weight: ${({ $fontWeight }) => $fontWeight || 600};
  color: ${({ $color }) => $color || 'inherit'};
`;

export default ThemedLabel;